export default function removeProtocolFromUrl(string) {
  return string.replace(/(^\w+:|^)/, "");
}



// WEBPACK FOOTER //
// ./template/helpers/removeProtocolFromUrl.js